// extracted by mini-css-extract-plugin
module.exports = {"root":"MainNav_root__1GIxc"};